/**
 * Enum for the possible `status` values on a lawn plan
 *
 * DEPRECATED
 * Prefer the subscriptionStatus enum found in features/subscriptions/subscription.js
 *
 * TODO: refactor this out
 */
export const planStatus = {
  SCHEDULED: 'sch', // renewal confirmed by customer and scheduled (NEXT YEAR)
  ACTIVE: 'act', // mostly the same for our concerns -- marked by CS after mapping
  COMPLETE: 'com', // cancelled their subscription after receiving all shipments
  CANCELLED: 'can', // (OLD VALUE) cancelled their plan
  AUTH_FAIL: 'aut', // annual subscription charge failed
};

export const sourceEngine = {
  LIQUID: 'liquid',
  GRANULAR: 'granular',
};

export const getCurrentPlan = (lawn) => {
  // Post-purchase lawn plan
  if (lawn && lawn.lawnPlans && lawn.lawnPlans.length > 0) {
    const currentYearPlans = lawn.lawnPlans.filter(
      (p) => p.year === lawn.currentPlanYear
    );

    /**
     * if there is more than one plan for the current year (e.g. due to cancellation + renewal)
     * select the non-cancelled plan, otherwise return the first plan in the list
     */
    if (currentYearPlans.length > 1) {
      return (
        currentYearPlans.find((p) => p.status !== planStatus.CANCELLED) ||
        currentYearPlans[0]
      );
    } else {
      return currentYearPlans[0];
    }
  }

  return null;
};

/**
 * Determine if the given plan doesn't start until next year.
 * Used to determine if a user is purchasing a plan at the end of
 * the year after we've stopped shipping
 */
export const planIsPreOrder = (plan) => {
  if (!plan) {
    return false;
  }

  return plan.year === new Date().getFullYear() + 1;
};

/**
 * Determine if the given plan is being sold with a discounted price
 */
export const planIsDiscounted = (plan) => {
  if (!plan || !plan.priceInfo) {
    return false;
  }

  return plan.priceInfo.fullPrice !== plan.priceInfo.unitPrice;
};
